import { Axios } from '../utils/request'

//  登录请求
export function searchname(name) {
    return Axios.get("/ApplyInfo/getAgentProjectByName", {
        params: {
            name
        }
    })
}
//  单点登录
export function accreditLogin(tel, tradingPlatformName, platformCode, registerNumber,isOrNoCommit) {
    return Axios.get("/erong/publicSsoLogin", {
        params: {
            tel, tradingPlatformName, platformCode, registerNumber,isOrNoCommit
        }
    })
}
//  优惠券
export function dzbhMoney(tradingPlatformName, marginAmount, guarantor, couponCode) {
    return Axios.get("/ApplyInfo/dzbhMoney", {
        params: {
            tradingPlatformName, marginAmount, guarantor, couponCode
        }
    })
}
//  用户登录名
export function getNickName() {
    return Axios.get("/erong/getNickName", {
        params: {
            
        }
    })
}
// // 下载电子保函原件
export function download(guaranteeUrl) {
    return Axios.post("/getDetails/download",
        {
            guaranteeUrl
        })
}
